<template>
    <div class="product-map">
        <div
            id="map"
            class="map"
        />
        <div class="product-map-location">
            <input
                v-model="position"
                @change="setLocation"
                placeholder="Zoek hier op locatie"
                type="text"
                name="location"
                class="form-control"
            >
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    import Icon from '@/components/icon';
    import gmaps from '@/plugins/gmaps';

    let google;
    let map;

    export default {
        name: 'map-store-finder',
        components: {
            Icon,
        },
        data() {
            return {
                current: '',
                currentId: null,
                bounds: null,
                stores: [],
                markers: [],
                position: '',
                imgUrl: '/app/themes/rugby/dist/images/',
            };
        },
        async mounted() {
            const { data } = await axios.get('/wp-json/23g-store-finder/v1/get');
            this.stores = data.filter(item => item.position.lat && item.position.lng);

            try {
                google = await gmaps.init(this.key);
                this.bounds = new google.maps.LatLngBounds();

                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 4,
                    disableDefaultUI: true,
                    zoomControl: true,
                });

                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: 'Midden nederland' }, (results, status) => {
                    if (status !== 'OK' || !results[0]) throw new Error(status);
                    map.setCenter(this.bounds.getCenter());
                    map.fitBounds(this.bounds);
                    map.setZoom(map.getZoom() - 1);
                });

                this.stores.forEach((store) => {
                    if (!store.position) this.getLatLong(`${store.street} ${store.number}, ${store.zipcode}, ${store.city}`, this.stores.indexOf(store));
                    this.addMarker(store);
                });
            } catch (error) {
                console.error(error);
            }

            this.setCurrentLocation();

            eventHub.$on('searchedForLocation', (position) => {
                this.position = position;
                this.setLocation();
            });
        },
        methods: {
            addMarker(store) {
                const marker = new google.maps.Marker({
                    map,
                    id: store.id,
                    icon: `${this.imgUrl}pin.png`,
                    title: `${store.name}`,
                    address: `${store.address}`,
                    zipcode: store.zipcode,
                    city: store.city,
                    phone: store.phone,
                    position: {
                        lat: parseFloat(store.position.lat),
                        lng: parseFloat(store.position.lng),
                    },
                });

                marker.addListener('click', () => {
                    this.resetCurrent();
                    this.current = marker;
                    this.currentId = marker.id;
                    this.setCurrentStore();
                    this.showMoreInfo();
                });

                this.markers.push(marker);
                this.bounds.extend(marker.getPosition());
            },

            getLatLong(address, index) {
                axios.get('https://maps.googleapis.com/maps/api/geocode/json', { params: { address, key: this.key } })
                    .then(({ data }) => {
                        this.stores[index].position = data.results[0].geometry.location;
                    });
            },

            setCurrentLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        map.setCenter(pos);
                        map.setZoom(12);
                    });
                }
            },

            setCurrentStore() {
                eventHub.$emit('resetCurrent');
                this.current.setIcon(`${this.imgUrl}pin_active.png`);
            },

            setLocation() {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: `${this.position}, nederland` }, (results, status) => {
                    if (status !== 'OK' || !results[0]) {
                        throw new Error(status);
                    }

                    map.setCenter(results[0].geometry.location);
                    map.setZoom(12);
                });
            },

            resetCurrent() {
                if (!this.current) return;

                eventHub.$emit('resetCurrent');

                this.current = '';
                this.markers.forEach((item) => {
                    item.setIcon(`${this.imgUrl}pin.png`);
                });
            },

            showMoreInfo() {
                eventHub.$emit('scrollToActive', this.currentId);
            },
        },
    };
</script>

<style lang="scss">
    .map-container {
        position: relative;
        min-height: 600px;
        overflow: hidden;
        background-color: $gray;
    }
</style>

<style lang="scss" scoped>
    .map {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &-reset-button {
            appearance: none;
            display: inline-flex;
            padding: 0;
            margin-left: 12px;
            font-size: 14px;
            background: none;
            border: 0;
        }

        &-store-block {
            position: absolute;
            top: 20px;
            left: 20px;
            z-index: 20;
            align-items: center;
            justify-content: center;
            padding: 20px 20px;
            overflow: hidden;
            font-size: 16px;
            font-weight: bold;
            line-height: 1.4;
            color: #fff;
            background: $primary;

            .title {
                font-size: 24px;
                font-weight: bold;
            }

            .button {
                margin-top: 10px;
            }

            ul,
            a,
            u {
                color: #fff;
            }
        }
    }

    .product-map {
        margin: 0;
    }

    .product-map-location {
        position: absolute;
        bottom: 30px;
        left: 30px;
        width: calc(100% - 60px);
        max-width: 350px;
    }

    .product-close {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        color: rgba(#fff, 0.5);

        &:hover {
            color: #fff;
        }
    }

    .product-phone {
        transition: 0.3s;

        &:hover {
            color: rgba(#fff, 0.5);
        }
    }

    .more-info {
        color: #fff;
    }
</style>
